module.exports = __webpack_public_path__ + "img/DD_1000_1-1.cf2469ec.png";